<template>
  <v-content>
    <v-progress-linear
      :active="busy"
      :indeterminate="busy"
      absolute
      top
      color="primary"
    />
    <!-- <loading
      :active="busy"
      color="#a4ed13"
      opacity="0.1"
      :is-full-page="true"
    /> -->

    <router-view />

    <!-- <dashboard-core-footer /> -->
  </v-content>
</template>

<script>
  import { mapState } from 'vuex'
  
  export default {
    name: 'DashboardCoreView',

    computed: {
      ...mapState('app', ['busy']),
    },

    methods: {
      // doAjax() {
      //   this.isLoading = true;
      //   // simulate AJAX
      //   setTimeout(() => {
      //     this.isLoading = false
      //   }, 5000)
      // },
    },
    components: {
      // Loading: () => import('vue-loading-overlay'),
      // DashboardCoreFooter: () => import('./Footer'),
    },
  }
</script>
